/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Open_SavedInputs */

const en_inbox_open_saved = /** @type {(inputs: Inbox_Open_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open recipe`)
};

const de_inbox_open_saved = /** @type {(inputs: Inbox_Open_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezept öffnen`)
};

/**
* | output |
* | --- |
* | "Open recipe" |
*
* @param {Inbox_Open_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const inbox_open_saved = /** @type {((inputs?: Inbox_Open_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Open_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_inbox_open_saved(inputs)
	return en_inbox_open_saved(inputs)
});